import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/financial-documents/financial-document-row/:rowId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    rowId: string;
}
const mutationFn = ({ rowId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { rowId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteFinancialDocumentRow };
